<template>
  <div class="klass-container">
    <div class="klass-title">
      <span>基本信息</span>
      <span class="flex-empty"></span>
      <a-button v-if="!isEditStatus" class="fr" icon="edit" @click="isEditStatus = true"
        >编辑</a-button
      >
      <div v-else>
        <a-button
          type="primary"
          class="fr"
          :disabled="!canNameSubmit && !canSubmit"
          @click="updateKlassInfo"
          >提交</a-button
        >
        <a-button class="fr m-right-20" @click="resetKlassInfo">取消</a-button>
      </div>
      <a-button
        v-if="isManager"
        class="fr m-left-20"
        type="danger"
        @click="deactiveHandle"
        >撤销</a-button
      >
    </div>

    <div class="klass-content" v-if="isEditStatus">
      <div class="width-300">
        <a-upload
          :customRequest="(event) => customRequest(event, 'logo')"
          list-type="picture-card"
          :show-upload-list="false"
        >
          <app-image-view
            v-if="logoInfo.thumbnail_url"
            class="klass-logo_img"
            :mediaInfo="logoInfo"
          />
          <div v-else class="klass-logo_img">
            <svg-icon iconClass="photo"></svg-icon>
          </div>
        </a-upload>
        <p class="klass-logo_tips" v-if="logoInfo.thumbnail_url">点击图片修改班级头像</p>
      </div>
      <div class="klass-right">
        <div>
          <span class="klass-label required-field">班级名称</span>
          <a-input class="width-300" v-model="klassName" placeholder="请输入班级名称" />
        </div>
        <div>
          <span class="klass-label">班级介绍</span>
          <a-textarea
            class="klass-des"
            v-model="klassInfo.content"
            placeholder="请输入班级介绍，最多5000字"
            :auto-size="{ minRows: 5 }"
            :maxLength="2000"
            style="resize: none"
          />
        </div>
        <div>
          <span class="klass-label">班级背景</span>
          <span v-if="backgroundInfo.thumbnail_url" class="klass-background">
            <app-image-view class="klass-background_img" :mediaInfo="backgroundInfo" />
            <span class="klass-background_mask">
              <svg-icon
                iconClass="eye"
                class="m-right-30"
                @click="viewPhoto([backgroundInfo], 0)"
              ></svg-icon>
              <svg-icon iconClass="delete" @click="delBackground"></svg-icon>
            </span>
          </span>
          <a-upload
            v-else
            :customRequest="(event) => customRequest(event, 'background')"
            list-type="picture-card"
            :show-upload-list="false"
          >
            <div class="klass-photo">
              <svg-icon iconClass="plus"></svg-icon>
            </div>
          </a-upload>
        </div>
        <div class="klass-photolist">
          <span class="klass-label">班级照片墙</span>
          <app-image-view
            v-for="(item, index) in photoList"
            :key="item.id"
            class="klass-photo"
            :mediaInfo="item"
          >
            <span class="klass-photo_mask">
              <svg-icon
                iconClass="eye"
                class="m-right-10"
                @click="viewPhoto(photoList, index)"
              ></svg-icon>
              <svg-icon iconClass="delete" @click="delPhoto(index)"></svg-icon>
            </span>
          </app-image-view>
          <a-upload
            :customRequest="(event) => customRequest(event, 'photo')"
            list-type="picture-card"
            :show-upload-list="false"
          >
            <div class="klass-photo">
              <svg-icon iconClass="plus"></svg-icon>
            </div>
          </a-upload>
        </div>
      </div>
    </div>

    <div class="klass-content" v-else>
      <div class="width-300">
        <app-image-view
          v-if="logoInfo.thumbnail_url"
          class="klass-logo_img"
          :mediaInfo="logoInfo"
        />
        <span v-else class="klass-logo_img" :style="getBgStyle(klassLogo)"></span>
      </div>
      <div class="klass-right">
        <div class="klass-item width-100p">
          <span class="klass-label klass-item_label">班级名称</span>
          <span class="klass-item_value">{{ klassName || "--" }}</span>
        </div>
        <div class="klass-item">
          <span class="klass-label klass-item_label">班级介绍</span>
          <span class="klass-item_value">{{ klassInfo.content || "--" }}</span>
        </div>
        <div class="klass-item clearfix">
          <span class="klass-label klass-item_label">班级背景</span>
          <app-image-view
            v-if="backgroundInfo.thumbnail_url"
            class="klass-item_background cursour"
            :mediaInfo="backgroundInfo"
            @click="viewPhoto([backgroundInfo], 0)"
          />
          <a-empty v-else class="p-top-10 p-bottom-10 fl" description="班级背景照片" />
        </div>
        <div class="klass-photolist clearfix">
          <span class="klass-label klass-item_label dis-block m-bottom-10"
            >班级照片墙</span
          >
          <app-image-view
            v-for="(item, index) in photoList"
            :key="item.id"
            class="klass-photo"
            :mediaInfo="item"
            @click="viewPhoto(photoList, index)"
          />
          <a-empty
            class="p-top-10 p-bottom-10 fl"
            description="暂无班级照片"
            v-if="!teacherList.length"
          />
        </div>
      </div>
    </div>

    <div class="klass-title">
      <span>老师墙</span>
      <span class="flex-empty"></span>
      <div v-if="isManager">
        <a-button
          v-if="!isEditTeacherStatus"
          class="fr"
          icon="edit"
          @click="isEditTeacherStatus = true"
          >编辑</a-button
        >
        <div v-else>
          <a-button
            type="primary"
            class="fr"
            :disabled="!canSubmitTeacher"
            @click="operateTeacherHandle"
            >提交</a-button
          >
          <a-button class="fr m-right-20" @click="resetTeacherInfo">取消</a-button>
        </div>
      </div>
    </div>

    <div class="klass-teacher_list" v-if="isEditTeacherStatus">
      <div
        class="dis-line m-bottom-30 m-right-30"
        v-for="(item, index) in teacherList"
        :key="item.id"
        v-if="!item.isDel"
      >
        <span class="klass-teacher" :style="getBgStyle(avatrtUrl(item.avatar_url))">
          <span class="klass-teacher_mask" v-if="isManager">
            <svg-icon
              iconClass="delete"
              @click="delTeacherHandle(index, item)"
            ></svg-icon>
          </span>
        </span>
        <div style="text-align: center">{{ item.name }}-{{ item.role_name }}</div>
      </div>

      <div
        class="klass-teacher m-bottom-20"
        @click="showTeacherModalHandle"
        v-if="isManager"
      >
        <svg-icon iconClass="plus"></svg-icon>
      </div>
    </div>

    <div class="klass-teacher_list" v-else>
      <div
        class="dis-line m-bottom-30 m-right-30"
        v-for="(item, index) in teacherList"
        :key="item.id"
        v-if="!item.isDel"
      >
        <span
          class="klass-teacher"
          :style="getBgStyle(avatrtUrl(item.avatar_url))"
          @click="viewPhoto(teacherList, index, 'avatar_url')"
        >
        </span>
        <div style="text-align: center">{{ item.name }}-{{ item.role_name }}</div>
      </div>
      <a-empty
        class="p-top-10 p-bottom-10"
        description="暂无班级教师"
        v-if="!teacherList.length"
      />
    </div>
    <a-modal
      title="添加教师"
      v-model="modalInfo.visible"
      :confirm-loading="modalInfo.loading"
      @cancel="resetModal"
      @ok="okHandle"
    >
      <div class="klass-modal_item">
        <span class="klass-modal_label required-field">任教班级</span>
        <span>{{ klassName }}</span>
      </div>
      <div class="klass-modal_item">
        <span class="klass-modal_label required-field">任教职务</span>
        <a-select
          class="width-300"
          v-model="modalInfo.role_id"
          placeholder="请选择任教职务"
        >
          <a-select-option
            v-for="item in roleList"
            :value="item.id"
            :key="item.id"
            v-if="item.name && item.name.endsWith('老师')"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
      <div class="klass-modal_item">
        <span class="klass-modal_label required-field">任教老师</span>
        <a-select
          class="width-300"
          v-model="modalInfo.teacher_info_id"
          placeholder="请选择任教老师"
        >
          <a-select-option
            v-for="item in schoolTeacherList"
            :value="item.id"
            :key="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
    </a-modal>
    <app-view-img :imageList.sync="imageList" :imageIndex.sync="imageIndex" />
  </div>
</template>

<script>
import avatar from "@/assets/images/avatar.png";
import AppViewImg from "@/components/AppViewImg";
import AppImageView from "@/components/AppImageView";
import { uploadHandle } from "@/utils";
import KlassService from "@/api/klassService";
import TeacherInfoService, { teacherService } from "@/api/teacherService";
import { mapGetters } from "vuex";
import klassLogo from "@/assets/images/klass_logo.png";

export default {
  name: "klassDetail",
  components: { AppViewImg, AppImageView },
  data() {
    return {
      isEditStatus: false,
      isEditTeacherStatus: false,
      klassLogo,
      imageList: [],
      imageIndex: 0,
      klassName: undefined,
      logoInfo: {},
      backgroundInfo: {},
      klassInfo: {},
      teacherList: [],
      schoolTeacherList: [],
      photoList: [],
      modalInfo: {
        visible: false,
        loading: false,
        name: undefined,
        role_id: undefined,
      },
      klassId: undefined,
      originklassName: undefined,
      originKlassInfo: {},
      originTeacherList: [],
      isloading: true,
      isKlassLoading: true,
    };
  },

  computed: {
    ...mapGetters(["isManager", "klassList", "roleList", "teacherInfo"]),
    avatrtUrl() {
      return function (avatarUrl) {
        if (!avatarUrl || !avatarUrl.startsWith("http")) {
          return avatar;
        }
        return avatarUrl;
      };
    },
    getBgStyle() {
      return function (thumbnail_url) {
        return {
          background: `url(${thumbnail_url}) no-repeat center center`,
        };
      };
    },
    canSubmitTeacher() {
      const teacherList = this.teacherList.filter((teacher) => {
        if (teacher.id && teacher.isDel) {
          return true;
        }
        if (!teacher.id) {
          return true;
        }
        return false;
      });

      return teacherList.length > 0;
    },
    canNameSubmit() {
      if (this.originklassName !== this.klassName) {
        return true;
      }

      return false;
    },
    canSubmit() {
      const { logo, background, media_list, ...klassInfo } = this.originKlassInfo;

      if (JSON.stringify(this.logoInfo) !== JSON.stringify(logo)) {
        return true;
      }

      if (JSON.stringify(this.backgroundInfo) !== JSON.stringify(background)) {
        return true;
      }

      if (JSON.stringify(this.klassInfo) !== JSON.stringify(klassInfo)) {
        return true;
      }

      if (JSON.stringify(this.photoList) !== JSON.stringify(media_list)) {
        return true;
      }

      return false;
    },
  },

  created() {
    this.initHandle();
  },

  methods: {
    initHandle() {
      this.klassId = this.$route.query.id;
      if (this.klassId) {
        this.getKlassInfo();
        this.getKlassIntro();
        this.getTeacherList();
      }

      this.$store.dispatch("getKlassListService");

      if (this.isManager) {
        this.getSchoolTeacherList();
        this.$store.dispatch("getRoleListService");
      }
    },

    getTeacherList() {
      this.isloading = true;
      teacherService
        .getTeacherListService({
          isManager: false,
          klass_id: this.klassId,
        })
        .then((res = []) => {
          this.isloading = false;
          this.teacherList = res.map((item) => {
            item.role_name = item.role.name;
            return item;
          });

          this.originTeacherList = JSON.parse(JSON.stringify(this.teacherList));
        })
        .catch(() => {
          this.isloading = false;
        });
    },

    getSchoolTeacherList() {
      TeacherInfoService.getTeacherInfoListService({
        isManager: true,
        school_id: this.teacherInfo.school_id,
      }).then((res) => {
        this.schoolTeacherList = res || [];
      });
    },

    getKlassInfo() {
      KlassService.getKlassInfoService({ klassId: this.klassId }).then((res) => {
        this.klassName = res.name;
        this.originklassName = this.klassName;
      });
    },

    getKlassIntro() {
      this.isKlassLoading = true;
      KlassService.getKlassIntroService({ klassId: this.klassId })
        .then((res) => {
          this.isKlassLoading = false;
          const { logo, background, media_list, ...klassInfo } = res;
          this.originKlassInfo = JSON.parse(JSON.stringify(res));
          this.logoInfo = logo || {};
          this.backgroundInfo = background || {};
          this.photoList = media_list || [];
          this.klassInfo = klassInfo;
        })
        .catch(() => {
          this.isKlassLoading = false;
        });
    },

    delBackground() {
      this.backgroundInfo = {};
    },

    delPhoto(index) {
      this.photoList.splice(index, 1);
    },

    viewPhoto(source, index, type = "url") {
      if (!source[index][type] || !source[index][type].startsWith("http")) return;
      this.imageList = source
        .filter((item) => item[type] && item[type].startsWith("http"))
        .map((item) => item[type]);
      this.imageIndex = this.imageList.findIndex((item) => item === source[index][type]);
    },

    customRequest(event, type) {
      uploadHandle({ file: event.file, klassId: this.klassId }).then((imageObj) => {
        switch (type) {
          case "logo":
            this.logoInfo = imageObj;
            break;
          case "photo":
            this.photoList.push(imageObj);
            break;
          case "background":
            this.backgroundInfo = imageObj;
            break;
          default:
            break;
        }
      });
    },

    showTeacherModalHandle() {
      this.modalInfo = {
        visible: true,
        loading: false,
      };
    },

    delTeacherHandle(index, teacher) {
      this.$set(this.teacherList, index, {
        ...teacher,
        isDel: true,
      });
    },

    okHandle() {
      if (!this.modalInfo.role_id) {
        this.$message.warning("请选择任教职务");
        return;
      }

      const teacherInfo =
        this.schoolTeacherList.find(
          (item) => item.id === this.modalInfo.teacher_info_id
        ) || {};

      const teacher = {
        school_id: this.teacherInfo.school_id,
        klass_id: this.klassId,
        name: teacherInfo.name,
        teacher_info_id: this.modalInfo.teacher_info_id,
        role_id: this.modalInfo.role_id,
        user_id: teacherInfo.user_id,
        role_name: (
          this.roleList.find((role) => role.id === this.modalInfo.role_id) || {}
        ).name,
      };
      this.teacherList.push(teacher);
      this.resetModal();
    },

    resetModal() {
      this.modalInfo = {
        visible: false,
        loading: false,
        name: undefined,
        role_id: undefined,
      };
    },

    operateTeacherHandle() {
      const requestList = [];
      this.teacherList.forEach((teacher) => {
        if (teacher.id && teacher.isDel) {
          requestList.push(
            TeacherInfoService.deactivateKlassTeacherService({
              teacherId: teacher.id,
            })
          );
        } else if (!teacher.id) {
          requestList.push(TeacherInfoService.createKlassTeacherService(teacher));
        }
      });

      Promise.all(requestList)
        .then(() => {
          this.$message.success("操作成功");
          this.getTeacherList();
          this.isEditTeacherStatus = false;
        })
        .catch(() => {
          this.$message.error("操作失败，请重新操作");
        });
    },

    resetKlassInfo() {
      const originKlassInfo = JSON.parse(JSON.stringify(this.originKlassInfo));
      const { logo, background, media_list, ...klassInfo } = originKlassInfo;
      this.klassInfo = klassInfo;
      this.logoInfo = logo || {};
      this.backgroundInfo = background || {};
      this.photoList = media_list;
      this.klassName = this.originklassName;
      this.isEditStatus = false;
    },

    resetTeacherInfo() {
      this.teacherList = JSON.parse(JSON.stringify(this.originTeacherList));
      this.isEditTeacherStatus = false;
    },

    async updateKlassInfo() {
      if (!this.klassName.trim()) {
        this.$message.warning("班级名称不能为空");
        return;
      }

      const requestService = [];

      if (this.canNameSubmit) {
        requestService.push(
          KlassService.updateKlassInfoService({
            klassId: this.klassId,
            name: this.klassName.trim(),
          })
        );
      }

      if (this.canSubmit) {
        const params = {
          klassId: this.klassId,
          content: this.klassInfo.content ? this.klassInfo.content.trim() : "",
          logo_id: this.logoInfo.id,
          background_id: this.backgroundInfo.id,
          media_ids: this.photoList.map((item) => item.id),
        };
        requestService.push(KlassService.updateKlassIntroService(params));
      }

      Promise.all(requestService)
        .then(() => {
          this.$message.success("操作成功");
          if (this.canNameSubmit) {
            this.getKlassInfo();
          }
          if (this.canSubmit) {
            this.getKlassIntro();
          }
          this.isEditStatus = false;
        })
        .catch(() => {
          this.$message.error("操作失败，请重新操作");
        });
    },

    deactiveHandle() {
      this.$confirm({
        title: "提示信息",
        content: "是否撤销当前班级",
        okText: "确定",
        cancelText: "取消",
        centered: true,
        onOk: () => {
          return new Promise((resolve, reject) => {
            KlassService.deactiveService({ klassId: this.klassId })
              .then(() => {
                this.$message.success("操作成功");
                this.$router.back();
                resolve();
              })
              .catch(() => {
                reject();
                this.$message.error("操作失败，请重新操作");
              });
          });
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.klass {
  &-container {
    margin-top: 15px;
    margin-right: 100px;
    background-color: #ffffff;

    /deep/.ant-upload-picture-card-wrapper {
      display: inline-block;
      width: auto;
    }

    /deep/.ant-upload-select-picture-card {
      background-color: #ffffff;
      border: none;
    }

    /deep/.ant-upload {
      margin: 0 !important;
      padding: 0 !important;
    }
  }

  &-content {
    display: flex;
    flex-flow: nowrap row;
  }

  &-title {
    display: flex;
    flex-flow: nowrap row;
    align-items: center;
    height: 32px;
    padding: 15px 0;
    box-sizing: content-box;
    line-height: 32px;
    background: #f0f2f5;

    &::before {
      position: relative;
      top: 0px;
      display: inline-block;
      content: "";
      width: 6px;
      height: 6px;
      margin-right: 8px;
      background: #409eff;
      border-radius: 50%;
    }
  }

  &-right {
    width: calc(100% - 300px);
  }

  &-info {
    height: 290px;
    padding: 0 0 0 60px;
    border-radius: 8px;
    background: #ffffff;
  }

  &-label {
    display: block;
    height: 20px;
    margin: 22px 0 14px;
    font-size: 14px;
    color: #343c6a;
  }

  &-input {
    width: 360px;
    height: 32px;
    border-radius: 4px;
    border-color: #d5d5d5;
  }

  &-select {
    width: 540px;
    height: 32px;
    border-radius: 4px;
    border-color: #d5d5d5;
  }

  &-kinsfolk {
    min-height: 200px;
    padding: 0 80px 22px 60px;
    border-radius: 8px;
    background: #ffffff;
  }

  &-des {
    width: 770px;
    max-width: calc(100% - 30px);
  }

  &-photolist {
    width: 800px;
    max-width: calc(100% - 30px);
  }

  &-btn {
    border-radius: 8px;
  }

  &-del {
    float: right;
    width: 40px;
    height: 40px;
    margin-top: 52px;
    background: #fe5c73;
    border-radius: 50%;
    text-align: center;
    color: #ffffff;
    line-height: 40px;
    cursor: pointer;
  }

  &-deliver {
    height: 1px;
    margin: 30px 0 10px;
    background: #d4d4d4;
  }

  &-logo {
    &_img {
      display: block;
      position: relative;
      width: 153px;
      height: 153px;
      margin: 54px 73px 0;
      border-radius: 50%;
      background: #ececee;
      font-size: 40px;
      line-height: 153px;
      overflow: hidden;
      background-size: cover !important;
    }

    &_tips {
      text-align: center;
      color: #cccccc;
    }
  }

  &-background {
    display: block;
    width: 500px;
    position: relative;
    &_img {
      display: block;
      width: 500px;
      height: 300px;
    }
    &_mask {
      display: none;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
      color: #ffffff;
      text-align: center;
      cursor: pointer;
      z-index: 2;
      font-size: 40px;
    }

    &:hover {
      .klass-background_mask {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  &-photo {
    position: relative;
    float: left;
    width: 134px;
    height: 120px;
    border-radius: 4px;
    font-size: 28px;
    line-height: 120px;
    background: #ececee;
    margin: 0 25px 25px 0;
    overflow: hidden;
    cursor: pointer;
    background-size: cover !important;

    &_img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 100%;
      max-height: 100%;
    }

    &_mask {
      display: none;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
      color: #ffffff;
      text-align: center;
      cursor: pointer;
    }

    &:hover {
      .klass-photo_mask {
        display: block;
      }
    }
  }

  &-teacher {
    position: relative;
    display: inline-block;
    width: 89px;
    height: 89px;
    border-radius: 50%;
    font-size: 28px;
    line-height: 89px;
    background: #ececee;
    text-align: center;
    overflow: hidden;
    // margin: 0 30px 30px 0;
    cursor: pointer;
    background-size: cover !important;

    &_img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 100%;
      max-height: 100%;
    }

    &_mask {
      display: none;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
      color: #ffffff;
      text-align: center;
      cursor: pointer;
    }

    &_list {
      padding: 30px 73px 0 73px;
    }

    &:hover {
      .klass-teacher_mask {
        display: block;
      }
    }
  }

  &-modal {
    &_item {
      display: flex;
      flex-flow: nowrap row;
      align-items: center;
      margin-bottom: 20px;
    }

    &_label {
      width: 80px;
      margin-right: 20px;
      text-align: right;
    }
  }

  &-item {
    width: 400px;
    margin: 22px 0;

    &_label {
      height: 20px;
      margin: 0 0 10px 0;
      font-size: 14px;
      line-height: 20px;
      color: #343c6a;
      font-weight: bold;
    }

    &_background {
      display: block;
      width: 500px;
      height: 300px;
    }
  }
}
</style>
